import { render } from "./PerWeek.vue?vue&type=template&id=0523c87b"
import script from "./PerWeek.vue?vue&type=script&lang=js"
export * from "./PerWeek.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__